// extracted by mini-css-extract-plugin
export default {"filter":"styles_filter__Opzsn","filter__filter":"styles_filter__filter__54tuu","filter__active":"styles_filter__active__cUm1h","filter__amount":"styles_filter__amount__-FGGp"};